import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
		- Vi devas esti pli simpla, pli komprenebla, - admonas la Violonon la Bruamuzilo. 
		– Jen, ekzemple, min oni ĉiam plezure aŭskultas. Eĉ beboj komprenas!
		</p>
	`
	)
}

const itemName = {
	esp: 'Bru-amuzilo por beboj'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;